import { deepPurple } from '@mui/material/colors'
import React from 'react'

export const Divider = () => {
  return (
    <div style={{
      width: '16%',
      height: 12,
      backgroundColor: deepPurple[200],
      borderRadius: 24
    }}></div>
  )
}
